import { isEmpty, sortBy } from "@flaminem/utils";
import { EdgeDataDefinition, NodeDataDefinition } from "cytoscape";
import { v4 as uuidv4 } from "uuid";

import { Element } from "src/types/element";
import { PropertyValue } from "src/types/property";

import { normalizeString } from "../relatedCases.mappings";
import { RelatedCasesDisplayElementConfig } from "../relatedCases.typings";

// TODO: move to config in next tickets
export const elementCodes = {
  LegalRepresentative: "RepresentantLegal",
  Accountant: "ExpertComptable",
  Company: "Entreprise",
};

export const getSafeId = (id?: string) => id?.trim() || uuidv4();

export const getElementId = (caseElement: Element): string | undefined => {
  if (isEmpty(caseElement?.identifiers)) {
    return caseElement.id;
  }
  const prefix = `element:${caseElement.schemaElement.code}-`;
  const sorted = sortBy(caseElement.identifiers, "value");
  return prefix + sorted.map((identifier) => normalizeString(identifier.value)).join("|");
};

export const getIdentifierId = (value: string, type: string) => {
  const prefix = `identifier:${type}-`;
  return `${prefix}${normalizeString(value)}`;
};

export const getElementLabel = (
  caseElement: Element,
  elemConf: RelatedCasesDisplayElementConfig
) => {
  const isEmptyElement = isEmpty(caseElement.identifiers);
  if (isEmptyElement) {
    return "";
  }
  const fromIdentifiers = elemConf.value.identifiers
    ?.reduce<string[]>((values, identifierProp) => {
      const identifier = caseElement.identifiers?.find(
        (identifier) => identifier.schemaIdentifier.code === identifierProp
      );
      if (identifier) {
        values.push(identifier.value);
      }
      return values;
    }, [])
    .join(elemConf.value.separator || " ");

  return fromIdentifiers || "-";
};

// Makes sure that the node is always created with a valid id
export const createSafeNodeData = (data: NodeDataDefinition | EdgeDataDefinition) => {
  return {
    ...data,
    id: getSafeId(data.id),
  };
};

export const filterGraphElements = (
  elementsConfig: RelatedCasesDisplayElementConfig[],
  caseInfo: {
    propertyValues: PropertyValue[];
    elements: Element[];
  }
) => {
  const displayElements = elementsConfig.map((elem) => elem.code);

  // filter out elements which are not in the configuration
  return caseInfo.elements?.filter((elem) => displayElements.includes(elem.schemaElement.code));
};

export const getCaseId = (caseInfo: {
  caseId?: string;
  propertyValues?: PropertyValue[];
}): string | undefined => {
  return (
    (caseInfo?.propertyValues?.find((p) => p.property.code === "id")?.value.value as string) ??
    caseInfo.caseId
  );
};

export const getCarbonColor = (cssVar: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
};
